import { useDataChange } from 'Simple/Data.js'

function withLevels(actions = []) {
  let insideWait = false
  let displayOrder = 1
  let result = actions.map(action => {
    if (!action) return action

    if (action.type === 'wait') {
      insideWait = true
      let {
        displayOrder: _ignoredOrder,
        lastGroupItem: _ignoredFlag,
        ...rest
      } = action

      return {
        ...rest,
        level: 0,
      }
    }

    let leveledAction = {
      ...action,
      level: insideWait ? 1 : 0,
      displayOrder,
    }
    displayOrder += 1
    return leveledAction
  })

  result.forEach((action, index) => {
    if (!action || action.level !== 1) return
    let nextItem = result[index + 1]
    let prevItem = result[index - 1]
    let isNextBoundary = !nextItem || nextItem.level === 0
    let isPrevBoundary = !prevItem || prevItem.level === 0

    action.lastGroupItem = isNextBoundary

    if (isPrevBoundary && isNextBoundary) {
      action.singleGroupItem = true
    } else if ('singleGroupItem' in action) {
      delete action.singleGroupItem
    }
  })

  return result
}

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'automation',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      let actions = Array.isArray(inext.actions) ? [...inext.actions] : []
      actions[props.index] = next
      inext.actions = withLevels(actions)
    })
  }
}
